"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphFactory = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var factory_1 = require("../internal/factory");
var units_1 = require("../internal/units");
var unitToStyle_1 = require("../internal/unitToStyle");
exports.ParagraphFactory = factory_1.factory({
    name: 'Paragraph',
    settings: {
        font: units_1.UNITS.FONT,
        palette: {
            type: 'Object',
            properties: {
                text: units_1.UNITS.COLOR
            }
        }
    },
    $when: {},
    component: function (_a) {
        var settings = _a.settings;
        return styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Remove default browser margin */\n      margin: 0;\n\n     /* Style font */\n      ", "\n      color: ", ";\n    "], ["\n      /* Remove default browser margin */\n      margin: 0;\n\n     /* Style font */\n      ", "\n      color: ", ";\n    "])), unitToStyle_1.fontToStyle(settings.font), settings.palette.text);
    }
});
var templateObject_1;
